<template>
    <div class="pa-5 pt-0" v-if="activeProduct">
        <div>
            <strong>{{ "Logistics" | t }}:</strong>
        </div>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Boxes in the base layer" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.boxes_in_base_layer"
                    @input="updateField($event, 'boxes_in_base_layer')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Layers on the pallet" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.layers_on_pallet"
                    @input="updateField($event, 'layers_on_pallet')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Boxes on the pallet" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.boxes_on_pallet"
                    @input="updateField($event, 'boxes_on_pallet')"
                    @focus="generatePalletBoxCount"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                    append-outer-icon="fal fa-sync"
                    @click:append-outer="generatePalletBoxCount(true)"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Pallet height (EU)" | t }} (mm)</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.base_height"
                    @input="updateField($event, 'base_height')"
                    type="number"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Store from "../../../store";

export default {
    name: "logistics-edit-tab",
    data() {
        return {
            statusItems: ["active", "pending", "inactive"]
        };
    },
    computed: {
        ...mapState("ProductStore", ["activeProduct", "productCategories"])
    },
    methods: {
        ...mapMutations("ProductStore", ["changeClassificatorValue"]),
        updateField(value, field) {
            Store.commit("ProductStore/updateActiveProductProperty", { prop: field, value: value });
        },
        updateJsonField(value, field) {
            Store.commit("ProductStore/updateActiveProductJsonField", { prop: field, value: value });
        },
        generatePalletBoxCount(force = false) {
            let product = this.activeProduct;
            if (force) {
                const boxCount = product.boxes_in_base_layer * product.layers_on_pallet;
                Store.commit("ProductStore/updateActiveProductProperty", {
                    prop: "boxes_on_pallet",
                    value: boxCount
                });
                return;
            }

            if (
                product.boxes_in_base_layer &&
                product.boxes_in_base_layer > 0 &&
                product.layers_on_pallet &&
                product.layers_on_pallet > 0 &&
                !product.boxes_on_pallet
            ) {
                const boxCount = product.boxes_in_base_layer * product.layers_on_pallet;
                Store.commit("ProductStore/updateActiveProductProperty", {
                    prop: "boxes_on_pallet",
                    value: boxCount
                });
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
::v-deep .v-input__slot {
    min-height: 9px !important;
}
::v-deep .v-input__icon {
    padding-bottom: 8px;
}
</style>
